import { styled } from "../../../seenspire-library";

const TransWithStrong = styled.span`
  strong {
    padding-left: 1px;
    padding-right: 1px;
  }
`;

export { TransWithStrong };
